import { computed, inject, Injectable, Signal } from '@angular/core';
import { selectLoggedInUser } from '@core/store/auth/auth.selectors';
import { Store } from '@ngrx/store';
import { NavItem } from './menu-structure.service';

@Injectable({
  providedIn: 'root',
})
export class NavItemAccessService {
  private readonly store = inject(Store);
  private readonly loggedInUser = this.store.selectSignal(selectLoggedInUser);

  getAllowedToAccessNavItemsBySection(section: NavItem[]): Signal<NavItem[]> {
    return computed(() =>
      section.filter((item) => this.allowedToAccess(item)()),
    );
  }

  sectionHasAtLeastOneItemAllowedToAccess(section: NavItem[]): Signal<boolean> {
    return computed(() => section.some((item) => this.allowedToAccess(item)()));
  }

  // note: the sidebar item can only be accessed if
  // - the user has the required roles
  // - the required feature flag is enabled
  allowedToAccess(item: NavItem): Signal<boolean> {
    return computed(
      () =>
        this.isAuthorizedByUserRole(item) &&
        this.isAuthorizedByFeatureFlag(item)(),
    );
  }

  private isAuthorizedByUserRole(item: NavItem): boolean {
    const user = this.loggedInUser();
    if (user && user.roles) {
      return item.roles.some((role: string) => user.roles.includes(role));
    }
    return false;
  }

  private isAuthorizedByFeatureFlag(menuItem: NavItem): Signal<boolean> {
    return computed(() => {
      if (menuItem.requiredFeatureFlagOrSubscription) {
        return menuItem.requiredFeatureFlagOrSubscription();
      }
      return true;
    });
  }
}
